import { Outlet } from 'react-router-dom';

function PetLayout() {
    return <Outlet />;
}

export default PetLayout;
